function e(e){let t,n=!1;return((...r)=>(n||=(t=e(...r),!0),t))}export{e as memoize};
//# sourceMappingURL=utils.js.map
